import ToastMessage from '@/components/toasts/ToastMessage';

import tenant from '@/services/TenantService';
import useTenantStore from '@/store/tenant';
import { toast } from 'react-toastify';

export default function useTenantMutation(schema, id) {
  const { upsert } = useTenantStore();

  const mutationFn = async (data) => {
    const { data: res } = id
      ? await tenant.put(`${schema}/${id}`, data)
      : await tenant.post(`${schema}`, data);
    return res;
  };

  const onSuccess = (result, variables) => {
    upsert(
      {
        _id: result?.insertedId || id,
        ...variables,
      },
      schema,
    );

    toast.success(
      <ToastMessage
        title="Erfolg"
        subtitle={
          id
            ? 'Daten wurden erfolgreich aktualisiert.'
            : 'Daten wurden erfolgreich hinzugefügt.'
        }
      />,
    );
    return result;
  };

  const onError = ({ response: { data: error } }) => {
    toast.error(
      <ToastMessage title="Fehler beim Speichern" subtitle={error?.message} />,
    );
  };

  const mutateAsync = (data) => {
    return mutationFn(data).then((res) => onSuccess(res, data), onError);
  };

  return { mutateAsync };
}
